import type { JSX } from 'react';

import { Loader2 } from 'lucide-react';

import styles from './EndUserLoading.module.css';

/**
 * The loading state of a page an outsider opens: a hosted or client form.
 * Plain on purpose: no Revvly mark and none of the dashboard's rotating status
 * lines, which speak to our users, not to theirs.
 */
export function EndUserLoading(): JSX.Element {
  return (
    <div className={styles.Page} role="status" aria-label="Loading">
      <Loader2 className={styles.Spinner} aria-hidden="true" />
    </div>
  );
}

/**
 * Routes an outsider opens without a Revvly account. The app-wide gates (setup
 * check, session) still run there, but must not show the dashboard's splash.
 */
export function isEndUserPage(pathname: string = window.location.pathname): boolean {
  return pathname.startsWith('/f/');
}
